import { initializeApp } from 'firebase/app';
import {
    getAuth,
    GoogleAuthProvider,
    OAuthProvider,
    onAuthStateChanged,
    User
} from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyAlSle8_fXzGM7v1sAUeLUKHdhMckxLIvA",
    authDomain: "skitterbook-clean.firebaseapp.com",
    projectId: "skitterbook-clean",
    storageBucket: "skitterbook-clean.firebasestorage.app",
    messagingSenderId: "1049513804007",
    appId: "1:1049513804007:web:775ea282ee09660b396242"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Federated providers
const googleProvider = new GoogleAuthProvider();
const microsoftProvider = new OAuthProvider('microsoft.com');

// 🔑 Helper: subscribe to auth state changes
const subscribeToAuthChanges = (callback: (user: User | null) => void) => {
    return onAuthStateChanged(auth, callback);
};

export { auth, googleProvider, microsoftProvider, subscribeToAuthChanges };
